/* ==========================================================================
   Design System
   Pagination Styling
   ========================================================================== */
/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.m-pagination {
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-areas: "pag-btn-prev . pag-btn-next" "pag-form pag-form pag-form";
  row-gap: 0.9375rem;
}
.m-pagination__form {
  grid-area: pag-form;
  display: flex;
  flex-flow: wrap;
  place-content: center;
  gap: 0.625rem;
  padding: 0.3125rem;
  border-radius: 0.25rem;
  background: var(--gray-5);
  color: var(--gray);
}
.m-pagination__current-page {
  width: 2.8125rem;
  font-weight: 500;
  text-align: right;
}
.m-pagination__label {
  display: contents;
  white-space: nowrap;
}
.m-pagination__btn-prev {
  grid-area: pag-btn-prev;
}
.m-pagination__btn-next {
  grid-area: pag-btn-next;
}
@media only all and (min-width: 37.5625em) {
  .m-pagination {
    grid-template-areas: "pag-btn-prev pag-form pag-btn-next";
  }
  .m-pagination__btn-prev {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .m-pagination__btn-next {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}